import OliverText from "@builder/components/general/OliverText";
import SimpleCheckbox from "@builder/components/general/SimpleCheckbox";
import { ActionType } from "@common/build/types";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { updateStepperActions, ActionEditorItem } from "@builder/store/slices/actionBuilderSlice";

const ReOrder = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const dispatch = useAppDispatch();

    useEffect(() => {
        const action = {
            type: ActionType.RE_ORDER,
        };
        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if(JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id as string, item: updatedStep as ActionEditorItem }));
        }
    }, [actionStep, dispatch, id]);


    return (
        <div className="function-add-cart-note-wrapper">
        <div className="function-add-cart-note">
            <div className="function-checkbox-wrapper">
                <div className="function-checkbox-label-wrapper">
                    <OliverText text="ReOrder" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                    <OliverText
                        text="This will bring the selected order back into the current active cart, allowing it to be paid again and finalized"
                        size="xs"
                        weight="light"
                        translatePrefix="popup.actionBuilder."
                    />
                </div>
                <SimpleCheckbox callback={() => {}} checked={true} label="" value="" custom={false} />
            </div>
        
        </div>
    </div>
);
};

export default ReOrder;
